import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import RejectDropDown from "./RejectDropDown";
import PlanSwitch from "./PlanSwitch";

type Props = {}

const PlanHeader: React.FC<Props> = () =>
    <Paper elevation={4} sx={(theme) => ({
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(1),
        padding: theme.spacing(1),
        [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
            marginTop: theme.spacing(0),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(1),
        },
        '& input': { height: 10 },
    })}>
        <Grid container spacing={1} style={{ alignItems: "center" }}>
            <PlanSwitch />
            <RejectDropDown />
        </Grid>
    </Paper >

export default PlanHeader